<template>
  <div id="app">
    <header v-if="isAuthenticated" id="header" class="page-header bg-white box-shadow animate fadeInDown">
      <div class="navbar navbar-expand-lg" >
        <!-- btn to toggle sidenav on small screen -->
        <a class="d-lg-none i-con-h-a px-1" data-toggle="modal" data-target="#aside">
          <i class="i-con i-con-menu text-muted"></i>
        </a>
        <!-- brand -->
        <a href="/" class="navbar-brand">
          <img alt="Vue logo" src="./assets/librate-logo.png">
        </a>
        <!-- / brand -->

        <!-- Navbar collapse -->
        <!-- hide unused elements -->
        <div v-if="false" class="collapse navbar-collapse order-2 order-lg-1" id="navbarToggler">
          <form class="input-group m-2 my-lg-0 i-con-h-a ">
            <span class="input-group-prepend">
              <button type="button" class="btn no-shadow no-bg px-0"><i class="i-con i-con-search text-fade w-16"></i></button>
            </span>
            <input type="text" class="form-control no-border no-shadow no-bg typeahead" placeholder="Search..." data-plugin="typeahead">
          </form>
        </div>

        <ul class="nav navbar-menu order-1 order-lg-2">
          <!-- hide unused elements -->
          <li v-if="false" class="nav-item d-none d-sm-block">
            <a class="nav-link px-2 i-con-h-a" data-plugin="screenfull" data-toggle="tooltip" data-title="Fullscreen">
              <i class="i-con i-con-fullscreen"></i>
            </a>
          </li>
          <!-- hide unused elements -->
          <li v-if="false" class="nav-item dropdown">
            <a class="nav-link px-2 i-con-h-a" data-toggle="dropdown">
              <i class="i-con i-con-droplet solid text-success"></i>
            </a>
            <!-- ############ Setting START-->
            <div class="dropdown-menu dropdown-menu-center mt-3 w animate fadeIn">
              <div class="setting px-3">
                <div class="mb-2">
                  <strong>Setting:</strong>
                </div>
                <div class="mb-3" id="settingLayout">
                  <label class="ui-check my-1 d-block">
                    <input type="checkbox" name="stickyHeader">
                    <i></i>
                    <small>Sticky header</small>
                  </label>
                  <label class="ui-check my-1 d-block">
                    <input type="checkbox" name="stickyAside">
                    <i></i>
                    <small>Sticky aside</small>
                  </label>
                  <label class="ui-check my-1 d-block">
                    <input type="checkbox" name="foldedAside">
                    <i></i>
                    <small>Folded Aside</small>
                  </label>
                  <label class="ui-check my-1 d-block">
                    <input type="checkbox" name="hideAside">
                    <i></i>
                    <small>Hide Aside</small>
                  </label>
                </div>
                <div class="mb-2">
                  <strong>Color:</strong>
                </div>
                <div>
                  <label class="radio radio-inline ui-check ui-check-md">
                    <input type="radio" name="bg" value="">
                    <i></i>
                  </label>
                  <label class="radio radio-inline ui-check ui-check-color ui-check-md">
                    <input type="radio" name="bg" value="bg-dark">
                    <i class="bg-dark"></i>
                  </label>
                </div>
              </div>
            </div>
            <!-- ############ Setting END-->
          </li>
          <!-- Notification -->
          <!-- hide unused elements -->
          <li v-if="false" class="nav-item dropdown">
            <a class="nav-link px-2 i-con-h-a mr-lg-2" data-toggle="dropdown">
              <i class="i-con i-con-bell"><i></i></i>
              <span class="badge badge-pill badge-up bg-primary">9</span>
            </a>
            <!-- dropdown -->
            <div class="dropdown-menu dropdown-menu-right mt-3 w-md animate fadeIn p-0">
              <div class="scrollable hover" style="max-height: 250px">
                <div class="list list-row animates animates-fadeInUp">
                  <div class="list-item " data-id="15">

                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-success-lt" >
                            G
                      </span>
                      </a>
                    </div>

                    <div class="flex">


                      <div class="item-feed h-2x">
                        We attempted to charge your <a href='#'>Pro plan</a>
                      </div>


                    </div>

                  </div>
                  <div class="list-item " data-id="3">
                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-info-lt" >
                            <!-- MF <img src="../assets/img/a3.jpg" alt=".">-->
                      </span>
                      </a>
                    </div>

                    <div class="flex">
                      <div class="item-feed h-2x">
                        <a href='#'>@James</a> submit a support ticket
                      </div>
                    </div>
                  </div>
                  <div class="list-item " data-id="7">




                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-primary-lt" >
                            <!-- MF <img src="../assets/img/a7.jpg" alt=".">-->
                      </span>
                      </a>
                    </div>

                    <div class="flex">


                      <div class="item-feed h-2x">
                        <a href='#'>Grantt</a> Send you a invitation to SWO
                      </div>


                    </div>


                  </div>
                  <div class="list-item " data-id="9">


                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-info-lt" >
                            <!-- MF <img src="../assets/img/a9.jpg" alt=".">-->
                      </span>
                      </a>
                    </div>

                    <div class="flex">


                      <div class="item-feed h-2x">
                        Added to <a href='#'>GameTime</a> team
                      </div>


                    </div>


                  </div>
                  <div class="list-item " data-id="4">



                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-success-lt" >
                            <!-- MF <img src="../assets/img/a4.jpg" alt=".">-->
                      </span>
                      </a>
                    </div>

                    <div class="flex">


                      <div class="item-feed h-2x">
                        <a href='#'>@Eddel</a> upload a media
                      </div>


                    </div>



                  </div>
                  <div class="list-item " data-id="11">




                    <div>
                      <a href="#">
                      <span class="w-32 avatar circle bg-info-lt" >
                            K
                      </span>
                      </a>
                    </div>

                    <div class="flex">
                      <div class="item-feed h-2x">
                        Prepare the documentation for the <a href='#'>Fitness app</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex px-3 py-2 b-t">
                <div class="flex">
                  <span>6 Notifications</span>
                </div>
                <a href="setting.html">See all <i class="fa fa-angle-right text-muted"></i></a>
              </div>
            </div>
            <!-- / dropdown -->
          </li>

          <!-- User dropdown menu -->
          <li class="nav-item dropdown">
            <a href="#" data-toggle="dropdown" class="nav-link d-flex align-items-center py-0 px-lg-0 px-2 text-color">
          <span class=" mx-2 d-none l-h-1x d-lg-block text-right">
              <small class='text-fade d-block mb-1'>Willkommen</small>
            <span>Librate Admin</span>
          </span>
              <span class="avatar w-36">
            <!-- MF <img src="../assets/img/a1.jpg" alt="...">-->
          </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right w pt-0 mt-3 animate fadeIn">
              <div class="row no-gutters mb-2 text-center r-t b-b">
                <div class="col-4 b-r">
                  <a href="app.user.html" class="py-3 d-block i-con-h-a">
                    <i class="i-con i-con-users"><i></i></i>
                  </a>
                </div>
                <div class="col-4 b-r">
                  <a href="app.mail.html" class="py-3 d-block i-con-h-a">
                    <i class="i-con i-con-mail"><i></i></i>
                  </a>
                </div>
                <div class="col-4">
                  <a href="app.message.html" class="py-3 d-block i-con-h-a">
                    <i class="i-con i-con-comment"><i></i></i>
                  </a>
                </div>
              </div>
              <a class="dropdown-item" href="page.profile.html">
                <span>Profile</span>
              </a>
              <a class="dropdown-item" href="page.setting.html">
                <span>Account Settings</span>
              </a>
              <a class="dropdown-item" href="page.price.html">
                <span class="badge bg-success text-uppercase">Upgrade</span>
                <span>to Pro</span>
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="page.faq.html">
                Need help?
              </a>
              <a class="dropdown-item" href="signin.html">Sign out</a>
            </div>
          </li>
          <!-- Navarbar toggle btn -->
          <li class="nav-item d-lg-none">
            <a href="#" class="nav-link i-con-h-a px-1" data-toggle="collapse" data-toggle-class data-target="#navbarToggler">
              <i class="i-con i-con-nav text-muted"><i></i></i>
            </a>
          </li>
        </ul>
      </div>
    </header>
    <div id="main" class="layout-row flex">

      <!-- ############ LAYOUT START-->

      <side-navigation v-if="isAuthenticated"></side-navigation>

      <!-- ############ Content START-->
      <div id="content" class="flex">

        <!-- ############ Main START-->

        <router-view></router-view>

        <!-- ############ Main END-->
      </div>
      <!-- ############ Content END-->

      <!-- ############ LAYOUT END-->
    </div>
  </div>
</template>

<script>
import SideNavigation from "./components/SideNavigation/SideNavigation"

export default {
  name: 'app',
  components: {
    SideNavigation,
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  $color-black: #000000;
  $color-white: #ffffff;
  $color-grey: #dddddd;

  #content {
    overflow-y: auto;
  }

  #main {
    overflow-y: auto;
  }
  #app {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  ::-webkit-scrollbar-track
  {
    background-color: #F5F5F5;
    border-radius: 8px;
  }

  ::-webkit-scrollbar
  {
    width: 8px;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb
  {
    background-color: #888888;
    border-radius: 8px;
  }

  li .nav-text {
    text-align: left;
  }

  .form-section-header {
    padding: 10px 0 5px 0;
    margin-bottom: 2rem;
    margin-top: 3rem;
    border-bottom: 1px solid #ced4da;
    font-size: 0.7rem;
    text-transform: uppercase;
    font-weight: bold;

    &:first-child {
      margin-top: 0;
    }
  }

  .card-form {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
    padding: 2rem;
  }

  .form-buttons {
    margin-top: 2rem;
    display: flex;
    padding: 20px 0;
    justify-content: flex-end;
  }

  .menubar {

    margin-bottom: 1rem;
    transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

    &.is-hidden {
      visibility: hidden;
      opacity: 0;
    }

    &.is-focused {
      visibility: visible;
      opacity: 1;
      transition: visibility 0.2s, opacity 0.2s;
    }

    &__button {
      font-weight: bold;
      display: inline-flex;
      background: transparent;
      border: 0;
      color: $color-black;
      padding: 0.2rem 0.5rem;
      margin-right: 0.2rem;
      border-radius: 3px;
      cursor: pointer;

      &:hover {
        background-color: rgba($color-black, 0.05);
      }

      &.is-active {
        background-color: rgba($color-black, 0.1);
      }
    }
  }

  .review-editor {
    margin: 30px 0;
  }

  .ck-editor__editable {
    min-height: 200px;
  }

  /*
  .multiselect__tags {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.15);
    border: none;
    padding-left: 2rem;
    height: 3.6rem;
  }

  .multiselect__tag {
    background-color: #50e3c2;
  }

  .multiselect__select {

    height: 3.6rem;
  }

  .multiselect__option--highlight {
    background-color: #50e3c2;
  }

  .multiselect__tags-wrap {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .multiselect__single {
    background-color: transparent;
    color: #ffffff;
  }

  .multiselect__input {
    color: #ffffff;
    background-color: transparent;
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background: #999999;
    color: #fff;
  }
  */

  .col-form-label {
    color: #777777 !important;
  }

  .form-control {
    border-color: rgba(135, 150, 165, 0.25) !important;
  }

    .router-link-exact-active .nav-text{
        font-weight: bold;
    }

  .form-control.is-invalid {
      border-color: red !important;
  }

  [v-cloak] {
    display: none;
  }
</style>
